module.exports = __webpack_public_path__ + "static/media/bluebg.4089f632.png";